<template>
  <div class="outer-wrapper">
    <div class="left-wrapper">
      <div class="inner-wrapper">
        <div class="title">物品详情</div>
        <Tabs>
          <TabPane label="基本信息" icon="ios-information-circle-outline">
            <div class="content">
              <table class="base">
                <tr>
                  <td>物品名称：</td>
                  <td colspan="3" style="border-right: none">
                    {{ content.name }}
                  </td>
                </tr>
                <tr>
                  <td>属性：</td>
                  <td colspan="3" style="border-right: none">
                    {{ revealProperty(content.property) }}
                  </td>
                </tr>
                <tr>
                  <td>当前库存：</td>
                  <td>
                    <span
                      style="color: red; font-size: 16px; margin-right: 10px"
                      >{{ content.amount }}</span
                    >{{ content.pit }}
                  </td>
                  <td>警戒库存：</td>
                  <td>
                    <span style="margin-right: 10px">{{
                      content.alert_amount
                    }}</span
                    >{{ content.pit }}
                  </td>
                </tr>
                <tr>
                  <td>库位：</td>
                  <td>{{ content.position_A }}</td>
                  <td>货位：</td>
                  <td>{{ content.position_B }}</td>
                </tr>
                <tr>
                  <td>物品类别：</td>
                  <td>{{ content.catagory_ch }}</td>
                  <td>创建信息：</td>
                  <td>
                    {{
                      content.create_time
                        ? content.create_time.split(" ")[0]
                        : ""
                    }}--{{ content.create_account }}
                  </td>
                </tr>
              </table>
            </div>
          </TabPane>
        </Tabs>
      </div>
    </div>
    <div class="right-wrapper">
      <div class="inner-wrapper">
        <div class="title">进出库情况</div>
        <Tabs>
          <TabPane label="数据表" icon="ios-card-outline">
            <div>
              <one-goods-flow-list
                :columnsFormatData="columnsFormatFlow"
                :validOptions="['date_type', 'direction']"
                :goodsId="parseInt(goods_id)"
                askData="oneGoodsFlow"
                :refreshData="update_count"
                main_width="680px"
              ></one-goods-flow-list>
            </div>
          </TabPane>
          <TabPane label="库存变动图" icon="md-analytics">
            <one-goods-flow-chart
              :goodsObject="content"
              :chart_draw_again="update_count"
              :esize="{ height: '430px', width: '700px'}"
            ></one-goods-flow-chart>
          </TabPane>
          <TabPane label="库存存量图" icon="md-analytics">
            <one-goods-chart
              :goodsObject="content"
              :chart_draw_again="update_count"
              :esize="{ height: '430px', width: '700px'}"
            ></one-goods-chart>
          </TabPane>
        </Tabs>
      </div>
    </div>
  </div>
</template>
<script>
import oneGoodsFlowList from "@/components/Common/OneGoodsFlowList.vue";
import oneGoodsFlowChart from "@/components/Charts/OneGoodsFlow.vue";
import oneGoodsChart from "@/components/Charts/OneGoods.vue";
let userToken = localStorage.getItem("current_user_token");
export default {
  name: "goodsContent",
  components: {
    oneGoodsFlowList,
    oneGoodsFlowChart,
    oneGoodsChart
  },
  data() {
    return {
      update_count: 0,
      columnsFormatFlow: [
        {
          title: "操作时间",
          key: "dotime",
          align: "center",
          width: 150,
        },
        {
          title: "出库/入库",
          key: "direction",
          align: "center",
          width: 100,
        },

        {
          title: "变动数量",
          key: "amount",
          align: "center",
          width: 100,
        },
        {
          title: "来源/去向",
          key: "place",
          align: "center",
          width: 100,
        },
        {
          title: "原因",
          key: "reason",
          align: "center",
          width: 100,
        },
        {
          title: "备注",
          key: "remark",
          align: "center",
        },
      ],
      content: {},
    };
  },
  props: {
    goods_id: {
      type: String,
      default: "1",
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.get_data(to.params.goods_id);
    next();
  },
  created() {
    this.get_data();
  },
  methods: {
    get_data(id = null) {
      if (id === null) {
        id = this.goods_id;
      }
      this.$axios
        .post(this.$url + "/goods_content", {
          goods_id: id,
          userToken: userToken,
          askData: "normal",
        })
        .then((response) => {
          if (response.data.stat === "ok") {
            this.content = response.data.res_record;
            this.update_count++;
          } else {
            this.$Message.error("valid");
          }
        });
    },
    revealProperty(value) {
      let tmp;
      if (typeof value === "string" && value.length > 0) {
        tmp = JSON.parse(value);
      } else {
        tmp = {};
      }
      let text = "";
      if (tmp.spec) {
        text += "规格:" + tmp.spec + ";";
      }
      if (tmp.model) {
        text += "型号:" + tmp.model + ";";
      }
      if (tmp.mat) {
        text += "材质:" + tmp.mat + ";";
      }
      if (tmp.volume) {
        text += "容积:" + tmp.volume + ";";
      }
      if (tmp.brand) {
        text += "品牌:" + tmp.brand + ";";
      }
      if (tmp.seller) {
        text += "供货商:" + tmp.seller + ";";
      }
      if (tmp.diameter) {
        text += "外径:" + tmp.diameter + ";";
      }
      if (tmp.bore) {
        text += "内径:" + tmp.bore + ";";
      }
      if (tmp.thickness) {
        text += "壁厚:" + tmp.thickness + ";";
      }
      if (tmp.pressure) {
        text += "压力:" + tmp.pressure + ";";
      }
      if (tmp.standard) {
        text += "标准:" + tmp.standard + ";";
      }
      if (tmp.grade) {
        text += "级别:" + tmp.grade + ";";
      }
      if (tmp.other) {
        text += "其他:" + tmp.other + ";";
      }
      return text;
    },
  },
};
</script>
<style scoped>
.outer-wrapper {
  min-height: 500px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.title {
  text-align: center;
  font-size: 24px;
  line-height: 300%;
}

.left-wrapper,
.right-wrapper {
  width: 700px;
}

.inner-wrapper {
  margin: 20px 10px;
}

.content {
  border: 1px solid #ddd;
  padding: 20px 10px;
}
table {
  width: 100%;
  border-collapse: collapse;
}
table.base > tr > td {
  padding: 20px 10px;
  border-bottom: 1px solid #eee;
  text-align: center;
  width: 30%;
  font-weight: 600;
  color: #333;
  word-break: break-all;
}

table.base > tr:last-child > td {
  border-bottom: none;
}

table.base > tr > td:first-child,
table.base > tr > td:nth-child(3) {
  text-align: right;
  width: 20%;
  color: #666;
  font-weight: 400;
}
table.base > tr > td:nth-child(2) {
  border-right: 1px solid #ccc;
}

.nothing {
  text-align: center;
  padding: 143px;
}
</style>